const urlOf = (path: string) => `${window.location.origin}${path}`;

// The inventory Home page — the default landing, on the bare community
// index route.
const inventoryPath = (inventoryId: number) => `/communities/${inventoryId}`;

// The Pathway product (on ledger) — list + detail. The bare `pathways`
// route belongs to the product; the legacy pages live under the qualified
// `pathway-scenarios` below.
const pathwaysPath = (inventoryId: number) =>
  `/communities/${inventoryId}/pathways`;

const pathwayPath = (inventoryId: number, pathwayId: number) =>
  `/communities/${inventoryId}/pathways/${pathwayId}`;

const baselinePath = (inventoryId: number) =>
  `/communities/${inventoryId}/baseline`;

const gpcPath = (inventoryId: number) => `/communities/${inventoryId}/gpc`;

const disclosuresPath = (inventoryId: number) =>
  `/communities/${inventoryId}/disclosures`;

const disclosurePath = (inventoryId: number, disclosureId: number) =>
  `/communities/${inventoryId}/disclosures/${disclosureId}`;

// The disclosure detail page selects its page via a `page` query param
// (mirrors suit's `disclosurePagePath`), so the sidebar can deep-link to
// each page without a route change.
const disclosurePagePath = (
  inventoryId: number,
  disclosureId: number,
  pageKey: string,
) => `${disclosurePath(inventoryId, disclosureId)}?page=${pageKey}`;

// The *legacy* pathway surface, reachable via the pinned "Legacy pathways"
// entry on the new Pathways list. The bare `pathways` URLs moved to the new
// product; legacy is qualified, matching its `pathway-scenarios` code name.
const pathwayScenariosPath = (inventoryId: number) =>
  `/communities/${inventoryId}/pathway-scenarios`;

const pathwayScenarioPath = (inventoryId: number, scenarioId: number) =>
  `/communities/${inventoryId}/pathway-scenarios/${scenarioId}`;

// The EF-scenario management surface — list + detail.
const scenariosPath = (inventoryId: number) =>
  `/communities/${inventoryId}/scenarios`;

const scenarioPath = (inventoryId: number, scenarioId: number) =>
  `/communities/${inventoryId}/scenarios/${scenarioId}`;

export {
  urlOf,
  inventoryPath,
  pathwaysPath,
  pathwayPath,
  pathwayScenariosPath,
  pathwayScenarioPath,
  scenariosPath,
  scenarioPath,
  baselinePath,
  gpcPath,
  disclosuresPath,
  disclosurePath,
  disclosurePagePath,
};
